import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
import { OverlayScrollbars } from 'overlayscrollbars';
import zhCnLocale from 'element-plus/es/locale/lang/zh-cn';
import enLocale from 'element-plus/es/locale/lang/en';
export default {
  data() {
    return {
      osInstance: null,
      imageViewerObserver: null
    };
  },
  computed: {
    adminAuthWarningVisible: {
      get() {
        return this.$store.state.adminAuthWarningVisible;
      },
      set(value) {
        if (!value) this.$store.commit('dismissAdminAuthWarning');
      }
    },
    ...mapGetters(['userConfig', 'useDarkMode']),
    elementLocale() {
      return this.$i18n.locale === 'zh-CN' ? zhCnLocale : enLocale;
    }
  },
  mounted() {
    // 初始化 OverlayScrollbars 悬浮滚动条
    this.$nextTick(() => {
      this.initOverlayScrollbars();
      this.setupImageViewerObserver();
    });
  },
  beforeUnmount() {
    // 清理 MutationObserver
    if (this.imageViewerObserver) {
      this.imageViewerObserver.disconnect();
    }
  },
  watch: {},
  methods: {
    openSecuritySettings() {
      this.$store.commit('dismissAdminAuthWarning');
      this.$router.push('/systemConfig#security');
    },
    initOverlayScrollbars() {
      try {
        // 检查是否已经初始化
        if (OverlayScrollbars.valid(document.body)) {
          this.osInstance = OverlayScrollbars(document.body);
          return;
        }

        // 应用到 body 实现全局悬浮滚动条
        this.osInstance = OverlayScrollbars(document.body, {
          scrollbars: {
            theme: 'os-theme-dark',
            visibility: 'auto',
            autoHide: 'scroll',
            autoHideDelay: 600,
            dragScroll: true,
            clickScroll: true
          },
          overflow: {
            x: 'hidden',
            y: 'scroll'
          }
        });
        console.log('OverlayScrollbars initialized successfully');
      } catch (error) {
        console.error('Failed to initialize OverlayScrollbars:', error);
      }
    },
    setupImageViewerObserver() {
      // 监听图片预览器的打开/关闭，动态控制 OverlayScrollbars
      this.imageViewerObserver = new MutationObserver(mutations => {
        const imageViewer = document.querySelector('.el-image-viewer__wrapper');
        if (imageViewer) {
          // 图片预览器打开，禁用滚动
          if (this.osInstance) {
            this.osInstance.options({
              overflow: {
                x: 'hidden',
                y: 'hidden'
              }
            });
          }
        } else {
          // 图片预览器关闭，恢复滚动
          if (this.osInstance) {
            this.osInstance.options({
              overflow: {
                x: 'hidden',
                y: 'scroll'
              }
            });
          }
        }
      });
      this.imageViewerObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
};